<template>
    <Fragment>
        <NavbarFirst />
        <NavbarSecond />
        <SideBar />
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import NavbarFirst from '../components/NavBar/First';
import NavbarSecond from '../components/NavBar/Second';
import SideBar from '../components/SideBar/Index';

export default {
    components: { 
        NavbarFirst, 
        NavbarSecond,
        SideBar,
        Fragment
    }
}
</script>

<style>

</style>